import { assertIsUUID } from '@bizzdesign/bizzdesign-sdk/uuid';
import { type DiagramPayload } from '@bizzdesign/modeler/models';
import { type ILogObj, type Logger } from 'tslog';

export function validateDiagramPayloadFields(
  diagramPayload: DiagramPayload,
  logger?: Logger<ILogObj>,
): boolean {
  if (
    !('payload' in diagramPayload) ||
    !('fromRepoElements' in diagramPayload) ||
    !('metamodelMetadata' in diagramPayload)
  ) {
    return false;
  }

  if (!diagramPayload.metamodelMetadata?.currentMetamodelName) {
    return false;
  }

  // check if payload keys are all UUID
  if (diagramPayload.payload) {
    const propertyKeys = Object.keys(diagramPayload.payload);
    const arePropsUUID = propertyKeys.every((elementId) => {
      try {
        assertIsUUID(elementId);
        return true;
      } catch (e) {
        logger?.warn(`elementId ${elementId} is not uuid`, e);
        return false;
      }
    });
    return arePropsUUID;
  }

  // all expected fields are present
  return true;
}
